import request from '@/util/http.js'
export const login = (data) => {
  return request({
    url: '/login',
    method: 'post',
    data: data
  })
}
export const loginOut = (data) => {
  return request({
    url: '/mypub/loginOut',
    method: 'post',
    data: data
  })
}